import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import RoutesComponent from './routes';
import styled from 'styled-components';
import Footer from './components/Footer';

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <AppWrapper>
      <ContentWrapper>
        <RoutesComponent />
      </ContentWrapper>
      <Footer />
    </AppWrapper>
  </ThemeProvider>
);

export default App;
